import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { StyledTextSpan } from '../../Generic/Text/StyledText';
import StyledListItem from '../../Generic/List/StyledListItem';

export interface ListItemProps {
    title: string;
    url: string;
    className?: string;
}

const AnchorLink = styled.a`
    display: block;
    text-decoration: none;
`;

const ListItem: FC<ListItemProps> = ({ title, url }): ReactElement => (
    <StyledListItem>
        <AnchorLink href={url}>
            <StyledTextSpan textType="body2">{title}</StyledTextSpan>
        </AnchorLink>
    </StyledListItem>
);
export default ListItem;
